import React, { useEffect, useState } from 'react';
import { Button, Space, Typography, message, Badge } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

const { Text } = Typography;

// 从 package.json 中获取版本号
const packageJson = require('../../../package.json');
const currentVersion = packageJson.version;

const Footer: React.FC = () => {
  const [hasUpdate, setHasUpdate] = useState(false);

  useEffect(() => {
    // 检查版本更新
    const storedVersion = localStorage.getItem('app_version');

    if (!storedVersion) {
      // 首次访问，存储当前版本
      localStorage.setItem('app_version', currentVersion);
    } else if (storedVersion !== currentVersion) {
      // 版本有更新
      setHasUpdate(true);
      message.success(`应用已更新到版本 ${currentVersion}`);
      // 更新存储的版本号
      localStorage.setItem('app_version', currentVersion);
      // 存储更新时间
      localStorage.setItem('app_last_updated', new Date().toISOString());
    }
  }, []);

  const handleForceUpdate = () => {
    message.loading('正在清除缓存并更新...', 1);

    // 清除所有缓存
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }

    // 清除 localStorage 和 sessionStorage 中的缓存（保留重要数据如token）
    const preserveKeys = [
      'token',
      'user',
      'umi_locale',
      'app_version',
      'app_last_updated',
    ]; // 需要保留的关键数据
    const localStorageBackup: Record<string, string> = {};
    const sessionStorageBackup: Record<string, string> = {};

    // 备份重要数据
    preserveKeys.forEach((key) => {
      const localValue = localStorage.getItem(key);
      const sessionValue = sessionStorage.getItem(key);
      if (localValue) localStorageBackup[key] = localValue;
      if (sessionValue) sessionStorageBackup[key] = sessionValue;
    });

    // 清除所有存储
    localStorage.clear();
    sessionStorage.clear();

    // 恢复重要数据
    Object.entries(localStorageBackup).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
    Object.entries(sessionStorageBackup).forEach(([key, value]) => {
      sessionStorage.setItem(key, value);
    });

    // 添加时间戳强制刷新
    setTimeout(() => {
      const timestamp = Date.now();
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('_v', timestamp.toString());
      currentUrl.searchParams.set('_cache_bust', timestamp.toString());

      // 强制刷新页面
      window.location.replace(currentUrl.toString());
    }, 1200);
  };

  return (
    <div
      style={{
        padding: '16px 24px',
        borderTop: '1px solid #303030',
        backgroundColor: 'transparent',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Text style={{ fontSize: '12px', color: 'rgba(255, 255, 255, 0.65)' }}>
          版本 {currentVersion}
        </Text>
        <Badge dot={hasUpdate} offset={[-2, 2]}>
          <Button
            size="small"
            type="text"
            icon={<ReloadOutlined />}
            onClick={handleForceUpdate}
            style={{
              fontSize: '12px',
              padding: '4px',
              height: 'auto',
              color: 'rgba(255, 255, 255, 0.85)',
              border: 'none',
              minWidth: 'auto',
            }}
          />
        </Badge>
      </div>
    </div>
  );
};

export default Footer;
